import { render, staticRenderFns } from "./VIPSetting.vue?vue&type=template&id=f9b68170&scoped=true&"
import script from "./VIPSetting.vue?vue&type=script&lang=js&"
export * from "./VIPSetting.vue?vue&type=script&lang=js&"
import style0 from "./VIPSetting.vue?vue&type=style&index=0&id=f9b68170&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b68170",
  null
  
)

export default component.exports